const isMediaElement = (
  eventTarget: EventTarget | null,
): eventTarget is HTMLImageElement | HTMLVideoElement => {
  return !!(
    eventTarget &&
    "nodeName" in eventTarget &&
    (eventTarget.nodeName === "IMG" || eventTarget.nodeName === "VIDEO")
  );
};

/**
 * Takes an HTML event with image or video as target and sets an image to its src
 * attribute. This provides a fallback in the event that an image fails to load.
 * This util is commonly set to the 'error' event of an <img> element
 * @param event an HTML event with an image or video element as target
 * @returns undefined
 */
export default (event: string | Event) => {
  if (typeof event === "string") return;

  if (!isMediaElement(event.target)) return;

  try {
    if (event.target.nodeName === "VIDEO") {
      event.target.removeAttribute("srcset");
    }

    event.target.src = "/broken-image-fallback.png";
  } catch {
    // eslint-disable-next-line no-console
    console.error("failed to set fallback image");
  }
};
